import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

export default function AttendeesSearchList({
  attendees,
  eventId,
  selectedAttendee,
  onSearch,
  onSelectAttendee,
  adjustedHeight,
}) {
  return (
    <>
      <input
        type="text"
        onChange={onSearch}
        placeholder="Search Athletes..."
        className="border p-2 mb-0 w-full rounded-md"
      />
      <div
        className="mt-3 pr-4 -mr-4 overflow-auto"
        style={{ height: `${adjustedHeight + 20}px` }}
      >
        <ul className="list-none p-0 mt-0">
          {attendees.length > 0 ? (
            attendees.map((athlete, index) => {
              const isSelected =
                selectedAttendee?.eventId === eventId &&
                selectedAttendee?.userAthlete?.userId === athlete.userId;

              return (
                <li
                  key={index}
                  className={`cursor-pointer px-3 py-2 mb-2 shadow rounded-lg border ${
                    isSelected
                      ? "border-red-300 bg-red-50 border-l-4"
                      : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                  }`}
                  onClick={() => onSelectAttendee(athlete)}
                >
                  <div className="flex justify-between items-center">
                    <div className="flex flex-row text-sm flex-1 space-x-3">
                      <div className="my-auto rounded-md">
                        <img
                          alt="Athlete Name"
                          src={
                            athlete.profilePicture || "/default-profile-img.png"
                          }
                          className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                        />
                      </div>
                      <div>
                        <span className="text-base lg:text-lg uppercase truncate flex items-center gap-3">
                          {athlete.jerseyNumber &&
                          athlete.jerseyNumber !== "null"
                            ? `(#${athlete.jerseyNumber}) `
                            : ""}
                          {athlete.name} {athlete.lastname}{" "}
                          {athlete?.tShirtSize !== null && (
                            <span className="t-shirt w-[3.7rem] pl-1">
                              <p className="text-white text-[9px] font-bold pl-5 relative -top-0.5">
                                {athlete?.tShirtSize}
                              </p>
                            </span>
                          )}
                        </span>

                        <div className="flex items-center gap-2">
                          <p className="text-sm text-gray-700">
                            {athlete.position}
                          </p>
                        </div>
                      </div>
                      <div className="ml-6">
                        {athlete.hasPositionDrills && (
                          <p className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-semibold leading-4 bg-green-500 text-white">
                            P
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex">
                      <div className="my-auto h-[40px] w-[40px] bg-blue-700 text-center text-white rounded-md mr-5 hidden">
                        <p className="my-auto text-base mt-2">
                          {athlete.positionScore}
                        </p>
                      </div>
                      <div
                        className={`ml-auto ${isSelected ? "text-red-300" : "text-gray-300"}`}
                      >
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="text-2xl font-bold"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <div className="mt-4 text-center text-md text-slate-600">
              <div className="w-full p-2 mt-5 flex flex-col items-center">
                <img
                  alt="No events that match your search"
                  src="/nodata.gif"
                  className="object-cover h-20 w-20 rounded-full border-gray-300 border"
                />
                <span className="mt-4 text-center text-md text-slate-600">
                  There are no records
                </span>
              </div>
            </div>
          )}
        </ul>
      </div>
    </>
  );
}
